module.exports = __webpack_public_path__ + "img/hero.1f3fa475.png";